import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import { getConviteECampos } from '@modules/convite/controllers/conviteController'
import { requestGetConviteReducers } from '@modules/convite/reducers/requestConviteReducer'
import conditionaRender from '@utils/conditionalRender'
import ViewDados from './views/ViewDados'
import ViewCadastro from './views/ViewCadastro'
import { useQuery } from '@utils/queryParams'
import './styles.scss'

const ConviteDados: React.FC = () => {

    const dispatch = useAppDispatch()
    const { convite } = useAppSelector(s => s.convite)
    const { requestGetConvite } = useAppSelector(s => s.requestConvite)
    const idVisitante = useQuery().get("idVisitante")

    const CR = conditionaRender(requestGetConvite, convite)

    useEffect(() => {
        if(!!idVisitante) getConviteECampos(dispatch, idVisitante.replaceAll(' ','+'))

        return () => {
            dispatch(requestGetConviteReducers.reset())
        }
    }, [dispatch, idVisitante])

    return(

        <>
            {CR.LOADING && <span>Carregando...</span>}
            {CR.ERROR && <span>{requestGetConvite.message}</span>}
            {CR.DATA && ((() => {
                if(convite!.flagEditado) return <ViewDados />
                return <ViewCadastro />
            })())}
        </>

    )

}

export default ConviteDados